module.exports = __webpack_public_path__ + "static/media/Lato-v15-latin-600.84af084c.woff";